import script from "./PrivacyPolicyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyPolicyModal.vue?vue&type=script&setup=true&lang=js"

import "./PrivacyPolicyModal.vue?vue&type=style&index=0&id=3a163af6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a163af6"]])

export default __exports__